import React, { useState } from 'react';
import { useColorTheme } from '../../context/ColorThemeContext';
import AchievementTimeline from './AchievementTimeline';
import AchievementRewards from './AchievementRewards';
import EnhancedLeaderboard from './EnhancedLeaderboard';
import { Trophy, Gift, Users } from 'lucide-react';

export const AchievementsPageV2 = ({ user, sessionToken }) => {
  const { colorTheme } = useColorTheme();
  const [activeTab, setActiveTab] = useState('achievements');

  const gradient = colorTheme === 'purple' ? 'from-purple-600 to-pink-600' : colorTheme === 'blue' ? 'from-blue-600 to-sky-500' : 'from-emerald-600 to-teal-500';
  const gradientBg = colorTheme === 'purple' ? 'from-purple-50/80 via-white to-pink-50/50' : colorTheme === 'blue' ? 'from-blue-50/80 via-white to-sky-50/50' : 'from-emerald-50/80 via-white to-teal-50/50';
  const activeBtn = colorTheme === 'purple' ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/20' : colorTheme === 'blue' ? 'bg-gradient-to-r from-blue-600 to-sky-500 text-white shadow-lg shadow-blue-500/20' : 'bg-gradient-to-r from-emerald-600 to-teal-500 text-white shadow-lg shadow-emerald-500/20';

  const tabs = [
    { id: 'achievements', label: 'Achievements', icon: Trophy },
    { id: 'rewards', label: 'Rewards', icon: Gift },
    { id: 'leaderboard', label: 'Leaderboard', icon: Users },
  ];

  return (
    <div className={`min-h-screen bg-gradient-to-br ${gradientBg} dark:from-slate-900 dark:via-slate-900 dark:to-slate-900`} data-testid="achievements-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className={`text-3xl font-bold bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}>Achievements</h1>
          <p className="text-slate-500 dark:text-slate-400 mt-1 text-sm">Track milestones, earn rewards, and see how you rank</p>
        </div>

        {/* Tabs */}
        <div className="bg-white/70 dark:bg-slate-800/50 backdrop-blur-xl border border-slate-200/50 dark:border-slate-700/50 rounded-2xl p-1.5 mb-8 flex gap-1 shadow-sm" data-testid="achievements-tabs">
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-xs font-semibold transition-all ${activeTab === tab.id ? activeBtn : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700/50'}`}
                data-testid={`tab-${tab.id}`}>
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        <div className="bg-white/70 dark:bg-slate-800/50 backdrop-blur-xl border border-slate-200/50 dark:border-slate-700/50 rounded-2xl shadow-sm overflow-hidden">
          {activeTab === 'achievements' && <AchievementTimeline user={user} />}
          {activeTab === 'rewards' && <AchievementRewards user={user} />}
          {activeTab === 'leaderboard' && <EnhancedLeaderboard user={user} />}
        </div>
      </div>
    </div>
  );
};

export default AchievementsPageV2;
